export const CURATED_STATUS = {
  draft: { label: "Borrador", variant: "secondary" },
  published: { label: "Publicado", variant: "default" },
  closed: { label: "Cerrado", variant: "outline" },
  archived: { label: "Archivado", variant: "outline" },
};

export const BOOKING_STATUS = {
  hold: { label: "Hold", cls: "bg-amber-100 text-amber-800" },
  secured: { label: "Depósito", cls: "bg-sky-100 text-sky-800" },
  paid: { label: "Pagada", cls: "bg-emerald-100 text-emerald-800" },
  expired: { label: "Expirada", cls: "bg-zinc-100 text-zinc-600" },
  cancelled: { label: "Cancelada", cls: "bg-rose-100 text-rose-700" },
  refunded: { label: "Reembolsada", cls: "bg-rose-100 text-rose-700" },
};

export const fmtMoney = (n, cur = "USD") =>
  new Intl.NumberFormat(cur === "EUR" ? "es-ES" : "en-US", { style: "currency", currency: cur, maximumFractionDigits: 0 }).format(Number(n) || 0).replace("US$", "$");

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString("es-ES", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }); } catch { return iso; }
};

export const imgUrl = (u) => (!u ? "" : String(u).startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

export const SERVICE_TYPES = [
  ["actividad", "Experience"], ["entradas", "Tickets"], ["transfer", "Transfer"], ["tren", "Train"],
  ["vuelo", "Flight"], ["comida", "Meal"], ["free_day", "Free time"],
];

export const uid = (p = "x") => `${p}_${Math.random().toString(36).slice(2, 10)}`;

export const addDays = (iso, n) => {
  if (!iso) return "";
  const d = new Date(`${String(iso).slice(0, 10)}T00:00:00`);
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
};

export const pickEditable = (t) => ({
  name: t.name, tagline: t.tagline || "", description: t.description || "", destination: t.destination || "",
  hero_image: t.hero_image || null, start_date: t.start_date || null, end_date: t.end_date || null,
  capacity: Number(t.capacity) || 1, price_single: Number(t.price_single) || 0, price_double: Number(t.price_double) || 0,
  currency: t.currency || "USD", deposit_pct: Number(t.deposit_pct) || 30,
  days: t.days || [], accommodations: t.accommodations || [], info_documents: t.info_documents || [],
  notify_emails: t.notify_emails || [],
});
